export default __webpack_public_path__ + "static/media/pantry1-afterG-1024w.32ae9828.webp";